export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PasswordChange.vue?vue&type=template&id=21e140b6"


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/changepass/PasswordChange.vue?vue&type=template&id=21e140b6
// module id = Fwlw
// module chunks = 41